import React from "react";

function PaymentAddressIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M32 0C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8C0 3.58172 3.58172 0 8 0H32Z"
        fill="url(#paint0_linear_1418_1323)"
      />
      <path
        d="M32 0C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8C0 3.58172 3.58172 0 8 0H32Z"
        stroke="#E5E7EB"
      />
      <path
        d="M12.5469 10.0853C12.8789 9.93294 13.2695 9.98763 13.5469 10.2259L15.125 11.5775L16.7031 10.2259C17.0547 9.92513 17.5742 9.92513 17.9219 10.2259L19.5 11.5775L21.0781 10.2259C21.4297 9.92513 21.9492 9.92513 22.2969 10.2259L23.875 11.5775L25.4531 10.2259C25.7305 9.98763 26.1211 9.93294 26.4531 10.0853C26.7852 10.2376 27 10.5697 27 10.9368V29.0618C27 29.429 26.7852 29.7611 26.4531 29.9134C26.1211 30.0657 25.7305 30.0111 25.4531 29.7728L23.875 28.4212L22.2969 29.7728C21.9453 30.0736 21.4258 30.0736 21.0781 29.7728L19.5 28.4212L17.9219 29.7728C17.5703 30.0736 17.0508 30.0736 16.7031 29.7728L15.125 28.4212L13.5469 29.7728C13.2695 30.0111 12.8789 30.0657 12.5469 29.9134C12.2148 29.7611 12 29.429 12 29.0618V10.9368C12 10.5697 12.2148 10.2376 12.5469 10.0853ZM15.75 15.6243C15.4062 15.6243 15.125 15.9056 15.125 16.2493C15.125 16.5931 15.4062 16.8743 15.75 16.8743H23.25C23.5938 16.8743 23.875 16.5931 23.875 16.2493C23.875 15.9056 23.5938 15.6243 23.25 15.6243H15.75ZM15.125 23.7493C15.125 24.0931 15.4062 24.3743 15.75 24.3743H23.25C23.5938 24.3743 23.875 24.0931 23.875 23.7493C23.875 23.4056 23.5938 23.1243 23.25 23.1243H15.75C15.4062 23.1243 15.125 23.4056 15.125 23.7493ZM15.75 19.3743C15.4062 19.3743 15.125 19.6556 15.125 19.9993C15.125 20.3431 15.4062 20.6243 15.75 20.6243H23.25C23.5938 20.6243 23.875 20.3431 23.875 19.9993C23.875 19.6556 23.5938 19.3743 23.25 19.3743H15.75Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1418_1323"
          x1="0"
          y1="20"
          x2="40"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2563EB" />
          <stop offset="1" stop-color="#7C3AED" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default PaymentAddressIcon;
